import api from './AxiosInstance.js';
import { setTokens, clearTokens, getRefreshToken } from '../auth/tokenStore';

const toError = (error) => {
  if (error.response) {
    return new Error(error.response.data?.message || error.response.data || 'Unknown server error');
  }
  return new Error(error.message || 'Network error');
};

const login = async ({ email, password }) => {
  try {
    const response = await api.post('Auth/login', { email, password });
    setTokens({ accessToken: response.data.accessToken, refreshToken: response.data.refreshToken });
    return response.data;
  } catch (error) {
    throw toError(error);
  }
};

const register = async ({ email, password, displayName, invite }) => {
  try {
    const response = await api.post('Auth/register', { email, password, displayName, invite });
    return response.data;
  } catch (error) {
    throw toError(error);
  }
};

const verifyEmail = async (token) => {
  try {
    const response = await api.post('Auth/verify-email', { token });
    return response.data;
  } catch (error) {
    throw toError(error);
  }
};

const forgotPassword = async (email) => {
  try {
    const response = await api.post('Auth/forgot-password', { email });
    return response.data;
  } catch (error) {
    throw toError(error);
  }
};

const resetPassword = async ({ token, newPassword }) => {
  try {
    const response = await api.post('Auth/reset-password', { token, newPassword });
    return response.data;
  } catch (error) {
    throw toError(error);
  }
};

const resendVerification = async (email) => {
  try {
    const response = await api.post('Auth/resend-verification', { email });
    return response.data;
  } catch (error) {
    throw toError(error);
  }
};

const logout = async () => {
  try {
    await api.post('Auth/logout', { refreshToken: getRefreshToken() });
  } catch {
    /* best-effort */
  } finally {
    clearTokens();
  }
};

const getMe = async () => {
  try {
    const response = await api.get('Auth/me');
    const data = response.data ?? {};
    return {
      ...data,
      name: data.displayName ?? data.email ?? '',
      role: data.userType ?? '',
    };
  } catch (error) {
    throw toError(error);
  }
};

const invite = async ({ email, features, roles, organizationId }) => {
  try {
    const response = await api.post('Auth/invite', { email, features, roles, organizationId });
    return response.data;
  } catch (error) {
    throw toError(error);
  }
};

const AuthService = {
  login,
  register,
  verifyEmail,
  forgotPassword,
  resetPassword,
  resendVerification,
  logout,
  getMe,
  invite,
};

export default AuthService;
